import { AxiosResponse } from "axios";
import axios from "../../../lib/axios";
import { API_ENDPOINTS } from "../../../constants/api_endpoints";
import { TResponse } from "../../../types/common";
import { IPageBannerPayload, IPageBannerResponse } from "../../../types/api/pageBanner";

/* ---------------------- Save Page Banner ---------------------- */
export async function savePageBanner(
  data: IPageBannerPayload
): Promise<AxiosResponse<TResponse<IPageBannerResponse>>> {
  return axios.post<TResponse<IPageBannerResponse>>(API_ENDPOINTS.PAGE_BANNER_SAVE, data);
}

/* ---------------------- Page Banner Detail ---------------------- */
export async function detailPageBanner(
  key: string
): Promise<AxiosResponse<TResponse<IPageBannerResponse>>> {
  return axios.get<TResponse<IPageBannerResponse>>(
    `${API_ENDPOINTS.PAGE_BANNER_DETAIL}/${key}`
  );
}